import CustomBarChart from './BarChart';
import CustomLineBarChart from './LineBarChart';
import CustomStepsBarChart from './StepsBarChart';
import CustomStackedBarChart from './StackedBarChart';

export const BarChart = CustomBarChart;
export const LineBarChart = CustomLineBarChart;
export const StepsBarChart = CustomStepsBarChart;
export const StackedBarChart = CustomStackedBarChart;
